import React from 'react'

import fallbackImage from '@app/assets/images/image-fallback.svg'

import styles from './styles.module.scss'

export const FallbackContentImageSlider: React.FC = () => {
  return (
    <div className={ styles.fallbackContentImageSlider }>
      <img src={ fallbackImage } />
      <span>Фото не загружено</span>
    </div>
  )
}
